module.exports = __webpack_public_path__ + "static/media/niezbednik_01_B.6b384cd4.png";